import React, { useState, forwardRef } from "react";
import ttAPI from '../../api/ttAPI';
import { Button } from '../../components/Wrappers'
import { Grid, Box, CircularProgress } from "@material-ui/core";
import "react-datepicker/dist/react-datepicker.css";
// components
import PageTitle from "../../components/PageTitle";
import Widget from "../../components/Widget";
import {DropzoneArea} from 'material-ui-dropzone'

// Icons
import {
    Publish as PublishIcon
} from '@material-ui/icons'

import { sendNotification } from "../../context/UserContext";
import useStyles from './styles';

const UploadCustomTests = forwardRef((props, ref) => {
    var classes = useStyles();

    const [isUploading, setIsUploading] = useState(false);
    const [fileObjects, setFileObjects] = useState([]);

    const onUpload = async () => {
        setIsUploading(true);
        if ( window.FileReader && window.FormData) {
           var formData = new FormData();
           var reader = new FileReader();
           // read
           reader.onload = async function(e) {
               var fileName = fileObjects[0].name;
               if (formData) {console.log(fileObjects[0]);
                   formData.append('files[]', fileObjects[0], fileName);

                   const response = await ttAPI.uploadMetrelCustomTests(formData);
                   setIsUploading(false);

                   var isOK = (response === undefined || response == null ||
                 		      response.data === undefined || response.data === null)
                 					? false :  response.data.ok === 'true';

                   if (isOK) {
                     sendNotification('success', 'Success - Metrel Custom Tests Uploaded. ' + response.data.message, classes);
                   }
                   else {
                     sendNotification('error', 'Error - Error Upload Metrel Custom Tests.' + ((response === undefined || response == null ||
                   		      response.data === undefined || response.data === null) ? '' : response.data.message), classes);
                   }
               }

           };
           reader.readAsDataURL(fileObjects[0]);
       }

    }

    return (
      <>
        <PageTitle title="Upload Metrel Custom Tests File" />
        <Grid container spacing={8}>
          <Grid item xs={12} md={12} lg={12}>
          <Widget
            title=""
            upperTitle
            className={classes.card}
            bodyClass={classes.fullHeightBody}
            disableWidgetMenu
            showOverflow
          >

            <div>
            <DropzoneArea
                      filesLimit={1}
                      showFileNames={true}
                      acceptedFiles={['.axml']}
                      dropzoneText={"Drag and drop a Metrel Custom Tests file here, XXX.axml"}
                      onChange={ newFileObjs => {setFileObjects(newFileObjs); }}
                      onDelete={ newFileObjs => {setFileObjects([]); }}
                      maxFileSize={2097152}
                    />

                    {fileObjects !== undefined && fileObjects !== null &&
                      fileObjects.length > 0 &&
                      <Button onClick={onUpload} disabled={isUploading}>
                        <Box>
                            <PublishIcon />
                        </Box>
                        {isUploading && <span><CircularProgress size={25}/> Uploading Metrel Custom Tests File...</span>}
                        {!isUploading && <span>Upload Metrel Custom Tests File</span>}
                    </Button>}
            </div>
            </Widget>
          </Grid>
        </Grid>
      </>
    );
});

export default UploadCustomTests;
